/**
 * Model for a dualScoreAdjustment.
 */
import { v4 as UUID } from 'uuid';
import { Team } from '@reg/shared/model';

export class DualScoreAdjustment {
    public id: string = null;
    public isNew: boolean = true;
    public eventId: string = null;
    public team: Team = null;
    public dualId: string = null;
    public score: number;
    public reason: string = null;

    public static getFields(): string[] {
        return [
            'eventId',
            'teamId',
            'team',
            'dualId',
            'score',
            'reason',
        ];
    }

    constructor() {
        this.id = UUID();
    }

    public clone(): DualScoreAdjustment {
        const clone: DualScoreAdjustment = new DualScoreAdjustment();
        clone.id = this.id;
        clone.isNew = this.isNew;
        clone.eventId = this.eventId;
        clone.dualId = this.dualId;
        clone.score = this.score;
        clone.reason = this.reason;
        clone.team = this.team && this.team.clone();

        return clone;
    }

    /**
     * Serialize to a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'dualScoreAdjustment';
        json.data.id = this.id;
        json.data.attributes = {};
        json.data.relationships = {};
        json.data.attributes.score = this.score ? parseFloat(this.score.toString()) : 0;
        json.data.attributes.reason = this.reason;

        if (this.team) {
            json.data.relationships.team = {
                data: { type: 'team', id: this.team.id },
            };
        }

        json.data.relationships.dual = { data: { type: 'dual', id: this.dualId } };

        return JSON.stringify(json);
    }

    /**
     * Deserialize from a json api format
     */
    public deserialize(json: Object, included: Object[] = null): DualScoreAdjustment {
        const data: Object = json['data'] || json;
        const attrs: Object = data['attributes'];
        const relationships: Object[] = data['relationships'] || [];
        included = included || json['included'];

        this.id = data['id'];
        this.isNew = false;
        this.eventId = attrs['eventId'];
        this.dualId = attrs['dualId'];
        this.reason = attrs['reason'];
        this.score = parseFloat(attrs['score']);

        const teamLink: Object = relationships['team'];
        if (teamLink &&
            included &&
            teamLink['data'] &&
            teamLink['data']['id']) {
            const teamId: string = teamLink['data']['id'];
            const team: Object[] =
                included.filter((i: Object) => i['type'] === 'team' && i['id'] === teamId);

            if (team.length === 1) {
                this.team = (new Team(this.eventId)).deserialize(team[0], included);
            }
        } else if (attrs['teamId']) {
            this.team = new Team(attrs['eventId'], attrs['teamId'], false);
        }

        return this;
    }
}
